import cookies from 'js-cookie';
import addRequestHeaders from './addRequestHeaders.js';

function xsrfCookieToHeader() {
    return addRequestHeaders(function () {
        var csrfToken = cookies.get('XSRF-TOKEN');
        if (csrfToken) {
            return { 'X-XSRF-TOKEN': csrfToken };
        }
        else {
            return {};
        }
    });
}

export default xsrfCookieToHeader;
//# sourceMappingURL=csrfHeader.js.map
